import React from 'react'

const OverclaimDocumentationWarning = () => (
    <p>
        Please note: Any documentation provided to The MLC may be shared internally within The MLC and externally with
        other Claimant(s) involved in the Conflict Procedure, including their agents and representatives.
        <br />
        <br /> Please review The MLC&apos;s{' '}
        <a href="https://www.themlc.com/policies" target="_blank" rel="noreferrer noopener">
            Dispute Policy{' '}
        </a>
        for more information.
    </p>
)
export default OverclaimDocumentationWarning
